import Component from '@glimmer/component';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';

import { isSimpleClick } from '@ember/-internals/views';
import PS from 'mewe/utils/pubsub';

export default class MwGroupMenuItem extends Component {
  @service router;

  feedRouteName = 'app.group.index.feed';

  refreshGroupFeed() {
    //only refresh when on feed page
    if (this.router.currentRouteName !== this.feedRouteName) {
      return;
    }

    later(
      this,
      function () {
        if (this.isDestroying || this.isDestroyed) return;

        const route = getOwner(this).lookup(`route:${this.feedRouteName}`);
        if (route) route.send('refreshFeed');
      },
      80
    );
  }

  @action
  openLink(e) {
    if (!isSimpleClick(e)) return;
    e.preventDefault();
    this.args.closeSearch?.(); // if component is used in group search results
    window.scrollTo(0, 0);
    PS.Pub('sidebar.action.mobile');

    if (this.args.group.newPosts > 0) {
      this.refreshGroupFeed();
    }

    this.router.transitionTo('app.group', this.args.group.id, {
      queryParams: {
        previewContext: 'group_invitations_section',
      },
    });
  }
}
